import { render } from "./CategorySort.vue?vue&type=template&id=11a89950&scoped=true"
import script from "./CategorySort.vue?vue&type=script&lang=js"
export * from "./CategorySort.vue?vue&type=script&lang=js"

import "./CategorySort.vue?vue&type=style&index=0&id=11a89950&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a89950"]])

export default __exports__